import { Component } from '@angular/core';
import { get } from 'lodash';
import { FieldType } from '@ngx-formly/core';
import { FormTooltipComponent } from '@shared/components/form-tooltip/form-tooltip.component';
import { ManageValidatorDisplayDirective } from '@features/client/form-builder/directives/hide-validator.directive';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-label-input',
  templateUrl: './label-input.component.html',
  styleUrls: ['./label-input.component.scss'],
  imports: [FormTooltipComponent, ManageValidatorDisplayDirective, AsyncPipe],
})
export class LabelInputComponent extends FieldType {
  public getValue: any = get;
}
